import { TrackImpressionDirective } from '@analytics/events';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InnogyComponentRendering } from '@core/jss-models';
import { GenericRichTextDirective, getFieldValue } from '@core/jss-utils';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import type { RichTextField } from '@sitecore-jss/sitecore-jss-angular';
import { CrntButton } from '@essent/current-web-angular';

@Component({
  selector: 'wl-email-consents-modal',
  templateUrl: './email-consents-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalComponent,
    ModalBodyDirective,
    GenericRichTextDirective,
    AutomationIdDirective,
    TrackImpressionDirective,
    CrntButton,
  ],
})
export class EmailConsentsModalComponent {
  private readonly activeModal = inject(NgbActiveModal);

  readonly rendering = signal<InnogyComponentRendering | undefined>(undefined);

  readonly energyAdviceEmailRejected = signal(false);
  readonly sustainabilityAdviceEmailRejected = signal(false);

  readonly content = computed(() => ({
    title: getFieldValue(this.rendering(), 'EmailConsentsModalTitle', ''),
    body: this.rendering()?.fields?.['EmailConsentsModalBody'] as RichTextField,
    energyAdviceCheckbox: getFieldValue(
      this.rendering(),
      'EmailConsentsModalEnergyAdviceCheckbox',
      ''
    ),
    sustainabilityCheckbox: getFieldValue(
      this.rendering(),
      'EmailConsentsModalSustainabilityCheckbox',
      ''
    ),
    primaryButton: getFieldValue(
      this.rendering(),
      'EmailConsentsModalPrimaryButton',
      ''
    ),
    secondaryButton: getFieldValue(
      this.rendering(),
      'EmailConsentsModalSecondaryButton',
      ''
    ),
  }));

  confirm() {
    this.activeModal.close({
      energyAdviceEmailRejected: this.energyAdviceEmailRejected(),
      sustainabilityAdviceEmailRejected:
        this.sustainabilityAdviceEmailRejected(),
    });
  }

  cancel() {
    this.activeModal.close();
  }
}
